import clsx from 'clsx';
import * as React from 'react';
import { useKiteModel } from '../hooks/useKiteModel';
import { Part } from '../types';

interface KiteModelProps {
    svg: string;
    templateKey?: string;
    removeStyle?: boolean;
    simple?: boolean;
    uncolored?: boolean;
    shadow?: boolean;
    onClick?: (partData?) => void;
    onHover?: (partData?) => void;
    selected?: Part;
    className?: string;
}

export default function KiteModel({
    templateKey,
    removeStyle,
    svg,
    simple,
    onClick,
    shadow,
    uncolored,
    selected,
    onHover,
    className,
}: KiteModelProps) {
    const model = useKiteModel(
        svg,
        removeStyle,
        simple,
        uncolored,
        onClick,
        onHover,
        selected
    );

    return (
        <div
            className={clsx('kite', className, {
                'with-shadow': shadow,
            })}
        >
            {model}
        </div>
    );
}
